const SECOND_MS = 1_000;
const MINUTE_MS = 60 * SECOND_MS;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

/**
 * Compact "how long ago" label for a timestamp, e.g. `42s ago` / `3m ago`.
 * Anything under 5 seconds (or in the future, from clock skew) reads
 * "just now" rather than a jittery small number.
 */
export function relativeAge(sinceMs: number, nowMs: number): string {
  const elapsed = nowMs - sinceMs;
  if (elapsed < 5 * SECOND_MS) return 'just now';
  if (elapsed < MINUTE_MS) return `${Math.floor(elapsed / SECOND_MS)}s ago`;
  if (elapsed < HOUR_MS) return `${Math.floor(elapsed / MINUTE_MS)}m ago`;
  if (elapsed < DAY_MS) return `${Math.floor(elapsed / HOUR_MS)}h ago`;
  return `${Math.floor(elapsed / DAY_MS)}d ago`;
}
